import AddVendorSliderAdminPartial from "../../../../partials/admin/menus/vendors/add-vendor-slider.admin.partial";

export default function AddVendorAdminScreen() {
  return <AddVendorSliderAdminPartial />;
}
